export const addLoadingBody = ({label}:{label?:string}={})=>{
    const body = document.querySelector('body');
    body.setAttribute('data-loading',label ?? 'Завантаження...')
    body.classList.add('bodyLoading')
}

export const removeLoadingBody = ()=>{
    const body = document.querySelector('body');
    body.classList.remove('bodyLoading')
    body.removeAttribute('data-loading')
}